export default "__VITE_ASSET__D$4e764F__"